import { useMemo } from "react";

import { formatDate } from "capitalrx-utilities";

import { PACaseResponse } from "@/api/interfaces/PACase";
import { getOverallOutcome, snakeCaseToTitleCase } from "@/utils";

export const usePaCaseOutcomeInfo = (paCase: PACaseResponse) => {
  return useMemo(() => {
    if (!paCase?.case_outcomes?.length) {
      return {};
    }
    const overallOutcome = getOverallOutcome(paCase.case_outcomes);
    const representativeOutcome = paCase.case_outcomes.find((outcome) => outcome.outcome == overallOutcome);
    if (!representativeOutcome) {
      return {};
    }
    const outcome: Record<string, string> = {
      "Decision Date": formatDate(representativeOutcome.updated_at, "MM/DD/YYYY hh:mma", true),
    };

    if (overallOutcome === "denied") {
      let denialType = representativeOutcome.denial_type;
      let denialReason = representativeOutcome.denial_reason;

      if (denialType === "missing_information") {
        denialReason =
          "The request is denied due to errors in the patient's demographic details, incorrect CPT/ICD codes, or inaccurate provider information";
      } else if (!denialReason) {
        denialReason = "";
      } else {
        denialReason = snakeCaseToTitleCase(denialReason);
      }

      if (denialType === "missing_information") {
        denialType = "Incomplete or Incorrect Information";
      } else if (!denialType) {
        denialType = "";
      } else {
        denialType = snakeCaseToTitleCase(denialType);
      }

      outcome["Denial Type"] = denialType;
      outcome["Denial Reason"] = denialReason;
    } else if (overallOutcome === "approved" && paCase.effective_date && paCase.expiration_date) {
      const effective = formatDate(paCase.effective_date, "MM/DD/YYYY", true);
      const expiration = formatDate(paCase.expiration_date, "MM/DD/YYYY", true);
      outcome["Active Dates"] = `${effective} - ${expiration}`;
    }

    return outcome;
  }, [paCase]);
};
